var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Account = (function (Account) {

        Account.Messages = (function (Messages) {

            Messages.GetUserAccount = function (model) {
                var data = {
                    model: model,
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserAccount', data);
            };
            Messages.GetUserAccount.className = 'Vendd.Account.Messages.GetUserAccount';

            Messages.GetUserAccountFailure = function (response) {
                var data = {
                    response: response,
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserAccountFailure', data);
            };
            Messages.GetUserAccountFailure.className = 'Vendd.Account.Messages.GetUserAccountFailure';

            Messages.GetUserAccountSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetUserAccountSuccess', data);
            };
            Messages.GetUserAccountSuccess.className = 'Vendd.Account.Messages.GetUserAccountSuccess';


            //TODO: Refactoring
            Messages.EditUser = function (observable, valEngine) {

                var valOptions = {
                    ValidationEngine: valEngine,
                    valmodel: observable.model
                };
                Vendd.DataValidation.ValidateModel(valOptions);


                var data = {
                    model: observable.model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditUser', data);
            };
            Messages.EditUser.className = 'Vendd.Account.Messages.EditUser';

            Messages.EditUserSuccess = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Account.Messages.EditUserSuccess", response);
            };
            Messages.EditUserSuccess.className = 'Vendd.Account.Messages.EditUserSuccess';

            Messages.EditUserFailed = function (response) {
                response.data = JSON.parse(response.data);
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Account.Messages.EditUserFailed", response);
            };
            Messages.EditUserFailed.className = "Vendd.Account.Messages.EditUserFailed";

            Messages.GetAddresses = function (addressType) {
                var data = {
                    addressType: addressType
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddresses', data);
            };
            Messages.GetAddresses.className = "Vendd.Account.Messages.GetAddresses";

            Messages.GetAddressesSuccess = function (model) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressesSuccess', model);
            };
            Messages.GetAddressesSuccess.className = 'Vendd.Account.Messages.GetAddressesSuccess';

            Messages.GetAddressesFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAddressesFailed', response);
            };
            Messages.GetAddressesFailed.className = 'Vendd.Account.Messages.GetAddressesFailed';


            Messages.EditAddress = function (observable, addressType) {
                var data = {
                    model: observable.model,
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddress', data, addressType);
            };
            Messages.EditAddress.className = 'Vendd.Account.Messages.EditAddress';


            Messages.EditAddressSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressSuccess', data);
            };
            Messages.EditAddressSuccess.className = 'Vendd.Account.Messages.EditAddressSuccess';

            Messages.EditAddressFailed = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.EditAddressFailed', data);
            };
            Messages.EditAddressFailed.className = 'Vendd.Account.Messages.EditAddressFailed';


            Messages.DeleteAddress = function (addressId, addressType) {
                var data = {
                    addressId: addressId,
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddress', data);
            };
            Messages.DeleteAddress.className = 'Vendd.Account.Messages.DeleteAddress';

            Messages.DeleteAddressSuccess = function (adressId) {
                var data = {
                    adressId: adressId
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressSuccess', adressId);
            };
            Messages.DeleteAddressSuccess.className = 'Vendd.Account.Messages.DeleteAddressSuccess';

            Messages.DeleteAddressFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.DeleteAddressFailure', data);
            };
            Messages.DeleteAddressFailure.className = 'Vendd.Account.Messages.DeleteAddressFailure';


            Messages.SetDefaultAddress = function (addressId, addressType) {
                var data = {
                    addressId: addressId,
                    addressType: addressType
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SetDefaultAddress', data);
            };
            Messages.SetDefaultAddress.className = 'Vendd.Account.Messages.SetDefaultAddress';

            Messages.SetDefaultAddressSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SetDefaultAddressSuccess', data);
            };
            Messages.SetDefaultAddressSuccess.className = 'Vendd.Account.SetDefaultAddressSuccess';

            Messages.SetDefaultAddressFailure = function (model) {
                var data = {
                    model: model

                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.SetDefaultAddressFailure', data);
            };
            Messages.SetDefaultAddressFailure.className = 'Vendd.Account.Messages.SetDefaultAddressFailure';


            Messages.CheckAddressIfExists = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressIfExists', data);
            };
            Messages.CheckAddressIfExists.className = 'Vendd.Account.Messages.CheckAddressIfExists';

            Messages.CheckAddressIfExistsSuccess = function (response) {
                var data = {
                    response: response
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressIfExistsSuccess', response);
            };
            Messages.CheckAddressIfExistsSuccess.className = 'Vendd.Account.Messages.CheckAddressIfExistsSuccess';

            Messages.CheckAddressIfExistsFailure = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.CheckAddressIfExistsFailure', data);
            };
            Messages.CheckAddressIfExistsFailure.className = 'Vendd.Account.Messages.CheckAddressIfExistsFailure';

            //TODO: Refactoring
            Messages.OpenAddressEditForm = function (observable, DoNotClone) {

                var address
                //  Clone Object 
                if (DoNotClone) {
                    address = observable;
                } else {
                    var modelCopy = jQuery.extend(true, {}, observable.model);
                    var observableCopy = new Vendd.Observable(modelCopy);
                    address = observableCopy;
                }

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.OpenAddressEditForm', address);
            };
            Messages.OpenAddressEditForm.className = 'Vendd.Account.Messages.OpenAddressEditForm';


            Messages.GetAreasForPostCode = function (observable, postCode, validateAfterLoad) {
                var data = {
                    country: observable.model.Country,
                    postCode: postCode,
                    area: observable.model.Area,
                    validateAfterLoad: validateAfterLoad
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasForPostCode', data);
            };
            Messages.GetAreasForPostCode.className = 'Vendd.Account.Messages.GetAreasForPostCode';

            Messages.GetAreasForPostCodeSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasForPostCodeSuccess', data);
            };
            Messages.GetAreasForPostCodeSuccess.className = 'Vendd.Account.Messages.GetAreasForPostCodeSuccess';

            Messages.GetAreasForPostCodeFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAreasForPostCodeFailed', response);
            };
            Messages.GetAreasForPostCodeFailed.className = 'Vendd.Account.Messages.GetAreasForPostCodeFailed';


            Messages.GetCountries = function (observable, addressType) {
                var data = {
                    selectedCountryCode: observable.model.Country,
                    addressType: addressType
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCountries', data);
            };
            Messages.GetCountries.className = 'Vendd.Account.Messages.GetCountries';

            Messages.GetCountriesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCountriesSuccess', data);
            };
            Messages.GetCountriesSuccess.className = 'Vendd.Account.Messages.GetCountriesSuccess';

            Messages.GetCountriesFailed = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCountriesFailed', response);
            };
            Messages.GetCountriesFailed.className = 'Vendd.Account.Messages.GetCountriesFailed';

            //todo: refactror 
            Messages.GetPrefecture = function (countryCode, area, postCode) {
                var data = {
                    postCode: postCode,
                    area: area,
                    countryCode: countryCode
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefecture', data);
            };
            Messages.GetPrefecture.className = 'Vendd.Account.Messages.GetPrefecture';

            Messages.GetPrefectureSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefectureSuccess', data);
            };
            Messages.GetPrefectureSuccess.className = 'Vendd.Account.Messages.GetPrefectureSuccess';

            Messages.GetPrefectureFailed = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetPrefectureFailed', response);
            };
            Messages.GetPrefectureFailed.className = 'Vendd.Account.Messages.GetPrefectureFailed';


            Messages.GetAllTaxAgencies = function (observable) {
                var data = {
                    countryCode: observable.model.Country
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllTaxAgencies', data);
            };
            Messages.GetAllTaxAgencies.className = 'Vendd.Account.Messages.GetAllTaxAgencies';

            Messages.GetAllTaxAgenciesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllTaxAgenciesSuccess', data);
            };
            Messages.GetAllTaxAgenciesSuccess.className = 'Vendd.Account.Messages.GetAllTaxAgenciesSuccess';

            Messages.GetAllTaxAgenciesFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllTaxAgenciesFailed', response);
            };
            Messages.GetAllTaxAgenciesFailed.className = 'Vendd.Account.Messages.GetAllTaxAgenciesFailed';

            Messages.GetAllVatStatuses = function (observable) {
                var data = {

                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllVatStatuses', data);
            };
            Messages.GetAllVatStatuses.className = 'Vendd.Account.Messages.GetAllVatStatuses';

            Messages.GetAllVatStatusesSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllVatStatusesSuccess', data);
            };
            Messages.GetAllVatStatusesSuccess.className = 'Vendd.Account.Messages.GetAllVatStatusesSuccess';

            Messages.GetAllVatStatusesFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetAllVatStatusesFailed', response);
            };
            Messages.GetAllVatStatusesFailed.className = 'Vendd.Account.Messages.GetAllVatStatusesFailed';

            Messages.AddressModelChanged = function (response) {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.AddressModelChanged', response);
            };
            Messages.AddressModelChanged.className = 'Vendd.Account.Messages.AddressModelChanged';

            Messages.ConvertPointsToCoupons = function (accountId) {
                var data = {
                    accountId: accountId,
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ConvertPointsToCoupons', data);

            };
            Messages.ConvertPointsToCoupons.className = 'Vendd.Account.Messages.ConvertPointsToCoupons';

            Messages.ConvertPointsToCouponsFailure = function (response) {
                var data = {
                    response: response,
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ConvertPointsToCouponsFailure', response);
            };
            Messages.ConvertPointsToCouponsFailure.className = 'Vendd.Account.Messages.ConvertPointsToCouponsFailure';

            Messages.ConvertPointsToCouponsSuccess = function (model) {
                var data = {
                    model: model
                };

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ConvertPointsToCouponsSuccess', data);
            };
            Messages.ConvertPointsToCouponsSuccess.className = 'Vendd.Account.Messages.ConvertPointsToCouponsSuccess';

            Messages.ReloadEditControl = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ReloadEditControl', {});
            };
            Messages.ReloadEditControl.className = 'Vendd.Account.Messages.ReloadEditControl';

            Messages.ReloadEditControlSuccess = function () {

                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.ReloadEditControlSuccess', {});
            };
            Messages.ReloadEditControlSuccess.className = 'Vendd.Account.Messages.ReloadEditControlSuccess';


            Messages.RequestToDeleteUser = function (model) {
                var data = { reason : model.Reason };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToDeleteUser', data);
            };
            Messages.RequestToDeleteUser.className = 'Vendd.Account.Messages.RequestToDeleteUser';

            Messages.RequestToDeleteUserSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToDeleteUserSuccess', data);
            };
            Messages.RequestToDeleteUserSuccess.className = 'Vendd.Account.Messages.RequestToDeleteUserSuccess';

            Messages.RequestToDeleteUserFailed = function(response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToDeleteUserFailed', response);
            };
            Messages.RequestToDeleteUserFailed.className = 'Vendd.Account.Messages.RequestToDeleteUserFailed';


            Messages.RequestToExportData = function () {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToExportData');
            };
            Messages.RequestToExportData.className = 'Vendd.Account.Messages.RequestToExportData';

            Messages.RequestToExportDataSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToExportDataSuccess', data);
            };
            Messages.RequestToExportDataSuccess.className = 'Vendd.Account.Messages.RequestToExportDataSuccess';

            Messages.RequestToExportDataFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.RequestToExportDataFailed', response);
            };
            Messages.RequestToExportDataFailed.className = 'Vendd.Account.Messages.RequestToExportDataFailed';

            Messages.GetCouponInformations = function (model) {
                var data = { couponCode: model.couponCode };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCouponInformations', data);
            };
            Messages.GetCouponInformations.className = 'Vendd.Account.Messages.GetCouponInformations';

            Messages.GetCouponInformationsSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCouponInformationsSuccess', data);
            };
            Messages.GetCouponInformationsSuccess.className = 'Vendd.Account.Messages.GetCouponInformationsSuccess';

            Messages.GetCouponInformationsFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.GetCouponInformationsFailed', response);
            };
            Messages.GetCouponInformationsFailed.className = 'Vendd.Account.Messages.GetCouponInformationsFailed';
            
            Messages.InvalidateCouponCode = function (model) {
                var data = { couponCode: model.couponCode };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.InvalidateCouponCode', data);
            };
            Messages.InvalidateCouponCode.className = 'Vendd.Account.Messages.InvalidateCouponCode';

            Messages.InvalidateCouponCodeSuccess = function (model) {
                var data = {
                    model: model
                };
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.InvalidateCouponCodeSuccess', data);
            };
            Messages.InvalidateCouponCodeSuccess.className = 'Vendd.Account.Messages.InvalidateCouponCodeSuccess';

            Messages.InvalidateCouponCodeFailed = function (response) {
                Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Account.Messages.InvalidateCouponCodeFailed', response);
            };
            Messages.InvalidateCouponCodeFailed.className = 'Vendd.Account.Messages.InvalidateCouponCodeFailed';



            return Messages;

        })(Account.Messages || {});

        return Account;

    })(Vendd.Account || {});

    return Vendd;

})(Vendd || {});